import type {
  Organization,
  ReportType,
  ReportFileType,
  PurchaserId,
  ReportParams,
} from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class HRPortalReportsDao {
  static async getReport(
    env: Environment,
    accessToken: string,
    purchaserId: PurchaserId,
    organization: Organization,
    reportType: ReportType,
    fileType: ReportFileType,
    params?: ReportParams
  ) {
    const url = hostsConfig[env].hrPortalAwsGateway;
    const { data, headers } = await axios.get(
      `${url}/reports/all/${purchaserId}/${organization}/${reportType}/${fileType}`,
      {
        params,
        headers: {
          Authorization: accessToken,
        },
        responseType: 'arraybuffer',
      }
    );

    const contentDispositionHeader = headers['content-disposition'];
    const contentTypeHeader = headers['content-type'];
    return { data, contentDispositionHeader, contentTypeHeader };
  }
}
